/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Theme, useTheme } from "@mui/material";
import { useEffect } from "react";

import { useBackgroundColor } from "../contexts/BackgroundContext";

export const useThemeBackgroundColor = (
  getThemeColor: (theme: Theme) => string,
  resetOnCleanup = true
) => {
  const theme = useTheme();
  const { setBackgroundColor, resetBackgroundColor } = useBackgroundColor();

  useEffect(() => {
    setBackgroundColor(getThemeColor(theme));

    return () => {
      if (resetOnCleanup) {
        resetBackgroundColor();
      }
    };
  }, [setBackgroundColor, resetBackgroundColor, getThemeColor, theme, resetOnCleanup]);

  return {
    setBackgroundColor,
    resetBackgroundColor,
    currentColor: getThemeColor(theme),
  };
};
